var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3877 0.171672C4.45623 -0.057224 6.54377 -0.057224 8.6123 0.171672C9.7576 0.299824 10.6816 1.20022 10.816 2.34758C11.0613 4.44205 11.0613 6.55792 10.816 8.65238C10.6816 9.79974 9.7576 10.7001 8.6123 10.8283C6.54377 11.0572 4.45623 11.0572 2.3877 10.8283C1.2424 10.7001 0.318408 9.79974 0.18402 8.65238C-0.0613401 6.55814 -0.0613401 4.44249 0.18402 2.34825C0.251995 1.79084 0.506536 1.27267 0.90639 0.877738C1.30624 0.482803 1.82798 0.234242 2.38703 0.172339M5.5 2.16737C5.63299 2.16737 5.76053 2.22011 5.85457 2.31399C5.94861 2.40787 6.00144 2.5352 6.00144 2.66796V4.99939H8.33684C8.46983 4.99939 8.59737 5.05213 8.69141 5.14601C8.78545 5.23989 8.83828 5.36722 8.83828 5.49998C8.83828 5.63275 8.78545 5.76008 8.69141 5.85396C8.59737 5.94784 8.46983 6.00058 8.33684 6.00058H6.00144V8.33201C6.00144 8.46477 5.94861 8.5921 5.85457 8.68598C5.76053 8.77986 5.63299 8.8326 5.5 8.8326C5.36701 8.8326 5.23946 8.77986 5.14542 8.68598C5.05139 8.5921 4.99855 8.46477 4.99855 8.33201V6.00058H2.66316C2.53017 6.00058 2.40263 5.94784 2.30859 5.85396C2.21455 5.76008 2.16172 5.63275 2.16172 5.49998C2.16172 5.36722 2.21455 5.23989 2.30859 5.14601C2.40263 5.05213 2.53017 4.99939 2.66316 4.99939H4.99855V2.66796C4.99855 2.5352 5.05139 2.40787 5.14542 2.31399C5.23946 2.22011 5.36701 2.16737 5.5 2.16737Z",
    fill: "#2DB0D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4412",
    x: 1,
    y: 1,
    width: 9,
    height: 8,
    fill: "#2DB0D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3 6.95848V8H4.04153L7.11333 4.92819L6.07181 3.88667L3 6.95848ZM7.91878 4.12275C7.94452 4.09705 7.96495 4.06653 7.97889 4.03293C7.99283 3.99934 8 3.96332 8 3.92694C8 3.89057 7.99283 3.85455 7.97889 3.82095C7.96495 3.78735 7.94452 3.75683 7.91878 3.73114L7.26887 3.08122C7.24317 3.05548 7.21265 3.03505 7.17905 3.02111C7.14545 3.00717 7.10943 3 7.07306 3C7.03668 3 7.00067 3.00717 6.96707 3.02111C6.93347 3.03505 6.90295 3.05548 6.87725 3.08122L6.36899 3.58949L7.41051 4.63101L7.91878 4.12275Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.a0f356b62c0867bc53412ebb48147221.svg";
export { ForwardRef as ReactComponent };